module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('em', [_vm._v("For Caitlin, Griffin and Hannah Marie")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "PrelimTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/ded#for"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(" by Dr. Nouriel Roubini")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230339934_02_int#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230339934_03_ch01#ch1"
    }
  }, [_vm._v("1   Excess Baggage: The West’s Struggle with Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780230339934_04_ch02#ch2"
    }
  }, [_vm._v("2   As the World Turns, Gravity Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_05_ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   A “Boiling Frog” Moment for America’s Middle Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_06_ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   From Shortwaves to Flash Mobs: Technology Speeds the March of History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_07_ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   In the Middle East, the Writing Is on the Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_08_ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   China and America: The Perils of Codependency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_09_ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   The Not-So-Pacific Rim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_10_ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8   India, Brazil, and the New American Dream Team")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_11_ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9   Europe: PIIGS, Canaries, and Bears—Oh My!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_12_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10   In the Game, or in Denial?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_13_ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_14_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780230339934_15_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "for"
    }
  }), _c('strong', [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "Author"
  }, [_c('em', [_vm._v("Dr. Nouriel Roubini")])]), _vm._v(" "), _c('p', {
    staticClass: "drt"
  }, [_c('strong', [_vm._v("I")]), _vm._v("n the autumn of 2011, global markets endured yet another phase of a European sovereign debt crisis. It started in tiny Greece and was allowed to spread, like a communicable disease, up the food chain of euro zone economies until the threat landed at the door of Italy and France, the eighth and sixth largest economies in the world, respectively. As in European crises of times past, when local leadership failed and the crisis threatened to spread beyond Europe’s borders, the call went out for someone, anyone, to save the day. Yet, contrary to the crises of the past century, beginning with World War I, the target of these urgent appeals was not the United States. Instead, emissaries from Italy, Greece, Ireland, and other distressed euro zone countries reached out to China, even if the willingness of China to bail out distressed euro zone members was more wishful thinking than reality.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Not long ago, the idea of a Group of Seven (G7) stalwart like Italy turning to the chief proponent of authoritarian state capitalism for economic help would have set off alarm bells in the United States. America would have intervened to engineer a rescue, as it did in Mexico in 1994, South Korea in 1998, Brazil in 1999, and in many other countries with emerging market crises, and as it had in both of the twentieth century’s great global conflicts. But the past three years have delivered a stark reality check to the superpower. Offering financial help to even its closest allies these days would be an exercise in keeping up appearances. America—and Japan, Britain, France, and, yes, even Germany—has its own problems.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("As Michael Moran argues in the forthcoming chapters of this book, "), _c('em', [_vm._v("The Reckoning: Debt, Democracy, and the Future of American Power,")]), _vm._v(" the world that emerged out of the cauldron of the American Century is in crisis. Much has been written about the relative decline of US economic and political influence, of the rise of the BRICS—Brazil, Russia, India, China, South Africa, and other emerging powers—and of the policy mistakes and demographic and debt problems that beset the old “West” and its Asian protégé, Japan. But few have considered the practical consequences for the United States and its allies as the economic and political status quo that American power has sustained in various regions all over the planet begin to show strain and fray and even break apart.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Just as the uncontrolled bankruptcy of Lehman Brothers nearly caused the global financial system to collapse in 2008, and just as the threat of the default of a relatively small sovereign player like Greece—or other euro zone sovereigns—could destroy the European common currency, an uncontrolled unraveling of US power would be a disaster of global proportions. As Moran writes, “as with Britain’s long retreat from global dominance in the early twentieth century, the pullback of American power in our time will expose, for the first time in decades, parts of the geopolitical shoreline that American might, political will, and diplomatic influence have heretofore sheltered.”")]), _vm._v(" "), _c('p', {
    staticClass: "AHead"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead1"
    }
  }, [_c('strong', [_vm._v("THE CRISIS OF THE DEVELOPED WORLD")])])]), _c('a', {
    attrs: {
      "id": "Prexivhead1"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_vm._v("Perhaps we should not be surprised that Italy’s desperate plea failed to set off alarm bells. After all, its appeal to China for massive purchases of Italian government debt followed the effective near insolvencies of three European states—Greece, Ireland, and Portugal—met feebly by European Union politicians with half measures, parochialism, and denial. Meanwhile, 2011 also witnessed the battering of Japan’s economy by a combination of natural, man-made, and policy-induced disasters—a combination that has Japan well into a third consecutive “lost decade” of debt and near depression. And, of course, there was the spectacle of a near default by the United States and the downgrade of its long-term credit rating by Standard & Poor’s (S&P).")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead1"
    }
  }, [_vm._v("How could this happen? As Moran persuasively argues, a good part of the problem is that, in Italy as in America and other advanced economies, the economic conversation today is driven by politicians and investment professionals—fund managers, traders, stock pickers. The former are crippled by a lack of knowledge, ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("partisan self-interest, and short-term electoral cycles; the latter are internally wired to maximize short-term profits even at the expense of long-term economic stability and to take positions—exacerbated by high-frequency trading—that fuel the volatility that underpins their returns. And all of this is amplified by the echo chamber of the financial media and blogosphere where the 24/7 news cycle of instant information is amplified by instant and often noisy commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("But today, more than three years after the collapse of Lehman Brothers shed light on the rot and misconceptions that underpinned capitalism in the early years of the twenty-first century, the world finds that it cannot pull back from the brink. Indeed, like a ship chugging with all its power against the pull of a mighty waterfall, the global economy is being starved of fuel by governments applying excessively front-loaded fiscal austerity, insisting on treating aggressively the long-term problem—too much private and public debt requiring deleveraging—even as the short-term weakness and crisis threaten to throw us all into the abyss.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("A swift (if thankless) reaction by central banks and economic policy makers in the wake of Lehman Brothers’ collapse in 2008 prevented a second great depression. This time, however, if wrong-headed policy measures push the world back into recession, it will be far more difficult to prevent the slide from ending in a full-blown depression and a financial crisis as bad as, if not worse than, the one in 2008–2009. The developed world is too indebted to save the day; the United States, economically and politically, has simply run out of policy bullets. Meanwhile, the emerging world lacks the institutional sophistication, political leadership, or the raw economic power required to pull the global economy away from the brink.")]), _vm._v(" "), _c('p', {
    staticClass: "AHead"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead2"
    }
  }, [_c('strong', [_vm._v("BULLETS AND BAILOUTS")])])]), _c('a', {
    attrs: {
      "id": "Prexivhead2"
    }
  }, [_c('p', {
    staticClass: "Text"
  }, [_vm._v("Until the middle of 2010, policy makers could always produce a new rabbit from their hat to fuel a modest economic recovery in the developed world. Government fiscal stimulus; near-zero interest rates from central bankers; two rounds of quantitative easing, or QE—essentially, printing money—from the US Federal Reserve; the ring-fencing of bad debt; and trillions of dollars in bailouts and liquidity provision for banks and financial institutions: officials tried them all. Now they have run out of rabbits.")])]), _c('p', {
    staticClass: "TextInd"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead2"
    }
  }, [_vm._v("Fiscal policy—the decision almost everywhere to radically cut spending and focus on the size of national debt rather than on the crisis at hand—is ")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("currently a tremendous drag on economic growth in both the euro zone and the United Kingdom. Even in the United States, and even if President Obama’s proposed $447 billion jobs bill were somehow to have to become law, state and local governments, and now the federal government, will still cut expenditures. Soon enough, they will be raising taxes to make up the shortfall between the demand for services and government revenues.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Another round of bank bailouts is politically unacceptable and economically unfeasible: most governments, especially in Europe, are so distressed that bailouts are unaffordable; indeed, their sovereign risk is actually fueling concern about the health of Europe’s banks, which hold most of the increasingly shaky government paper.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Nor could monetary policy help very much. Quantitative easing is constrained by above-target inflation in the euro zone and United Kingdom; it will occur, but it will be too little, too late. The Fed seems poised at this writing to launch a third round of quantitative easing (QE3), but it will also be too little, too late. Last year’s $600 billion QE2 and $1 trillion in tax cuts and transfers delivered growth of barely 3 percent for exactly one quarter before growth slumped to below 1 percent in the first half of 2011. QE3 will be much smaller and will do much less to reflate asset prices and restore growth. And more than traditional quantitative easing, central banks should engage in credit easing to ensure that the creation of credit, especially to small and medium-sized enterprises and to fragile households, is restored.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Currency depreciation is not a feasible option for all advanced economies: they all need a weaker currency and better trade balance to restore growth, but they all cannot have it at the same time. So relying on exchange rates to influence trade balances is a zero-sum game. Currency wars are thus on the horizon, with Japan and Switzerland engaging in early battles to weaken their exchange rates. Others, including the United States, will soon follow.")]), _vm._v(" "), _c('p', {
    staticClass: "AHead"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead3"
    }
  }, [_c('strong', [_vm._v("AVERTING THE FALL")])])]), _c('a', {
    attrs: {
      "id": "Prexivhead3"
    }
  }), _c('p', {
    staticClass: "Text"
  }, [_c('a', {
    attrs: {
      "id": "Prexivhead3"
    }
  }, [_vm._v("Is there a way to avoid disaster—to give the global economy’s engine room the burst of power it needs to pull away from the roaring falls? The right balance today requires creating jobs partly through additional fiscal stimulus aimed at productive infrastructure investment. It also requires more progressive taxation and more short-term fiscal stimulus with medium- and long-term fiscal discipline that begins, over time, to slow the mountain of debt most of the ")]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("world’s advanced economies have accumulated. This cannot be done quickly or easily: it will be, to quote Donald Rumsfeld, a long, hard slog.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("In the financial sector, steps are needed to shore up lender-of-last-resort support by monetary authorities to prevent ruinous runs on banks and especially sovereigns; banks need to recognize that it is in their interest (in some cases, literally a question of self-preservation) to lessen the debt burden for insolvent households, businesses, and government entities; global financial officials need to impose stricter supervision and regulation of a financial system that is still running amok, including the breakup of “too big to fail” banks and oligopolistic trusts; and short-term forbearance of capital ratios is needed to restore credit growth.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Similarly, as the forthcoming pages will argue, America and its allies must begin to build the structures, relationships, and rules that will maintain stability in the Pacific Rim, South Asia, Europe, Africa, and Latin America before US power deteriorates much further. The hedging, as you shall see, is already well under way among some of America’s closest allies. From Berlin to Ankara, Taipei to Tokyo, there is a growing realization that the American military—unsurpassed and dominant as it is—cannot remain so forever in the face of long-term economic stagnation, the march of disruptive technologies, and a growing ambition on the part of emerging regional powers to revisit some of the “givens” imposed upon their neighborhoods by Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "TextInd"
  }, [_vm._v("Over time, both the United States and other advanced economies it has provided security for over the course of the past 70 years will need to think about effecting a soft landing from the collective global dominance they engineered in the wake of World War II. This means investing less in satellite weaponry or hypersonic fighter aircraft—though these will still come in handy in an unpredictable world—and more in human capital, skills, and social safety nets to increase productivity and enable workers to compete, be flexible, and thrive in a globalized economy. The alternative is—as it was in the 1930s—unending stagnation, depression, currency and trade wars, capital controls, banking and financial crises, sovereign insolvencies, and massive social and political instability. In that scenario, no one—not China, not Russia, not America or Europe—wins. It is that scenario, above all, that "), _c('em', [_vm._v("The Reckoning")]), _vm._v(" seeks to avert.")]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURIEL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUBINI")])]), _vm._v(" "), _c('p', {
    staticClass: "Textr"
  }, [_c('em', [_vm._v("New York, December 2011")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4ea6dde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/ded.vue
// module id = 66
// module chunks = 0